import {
  BookOpenIcon,
  BriefcaseIcon,
  CalendarIcon,
  CameraIcon,
  CoffeeIcon,
  CrownIcon,
  FlagIcon,
  FlowerIcon,
  FolderIcon,
  GiftIcon,
  HeartIcon,
  LeafIcon,
  LightningIcon,
  MapPinIcon,
  MegaphoneIcon,
  MicrophoneIcon,
  PaletteIcon,
  RocketLaunchIcon,
  ShoppingBagIcon,
  SnowflakeIcon,
  StarIcon,
  StorefrontIcon,
  SunIcon,
  TShirtIcon,
  TagIcon,
  TargetIcon,
  TicketIcon,
  TrophyIcon,
  UsersIcon,
  VideoIcon,
} from '@phosphor-icons/react';

// 30 icons — fills a clean 5×6 grid with no empty slot. Curated for solo
// creators / SMB owners: business operations, content kinds, retail/seasonal,
// and a few community/lifestyle anchors. Adding a 31st triggers a layout
// rebalance — keep the grid divisible.
export const FOLDER_ICONS = [
  { id: 'megaphone', icon: MegaphoneIcon },
  { id: 'folder', icon: FolderIcon },
  { id: 'briefcase', icon: BriefcaseIcon },
  { id: 'star', icon: StarIcon },
  { id: 'lightning', icon: LightningIcon },
  { id: 'heart', icon: HeartIcon },
  { id: 'flag', icon: FlagIcon },
  { id: 'shopping-bag', icon: ShoppingBagIcon },
  { id: 'trophy', icon: TrophyIcon },
  { id: 'palette', icon: PaletteIcon },
  { id: 'video', icon: VideoIcon },
  { id: 'microphone', icon: MicrophoneIcon },
  { id: 'camera', icon: CameraIcon },
  { id: 'calendar', icon: CalendarIcon },
  { id: 'rocket-launch', icon: RocketLaunchIcon },
  { id: 'target', icon: TargetIcon },
  { id: 'tag', icon: TagIcon },
  { id: 'storefront', icon: StorefrontIcon },
  { id: 'ticket', icon: TicketIcon },
  { id: 'sun', icon: SunIcon },
  { id: 'snowflake', icon: SnowflakeIcon },
  { id: 'flower', icon: FlowerIcon },
  { id: 'leaf', icon: LeafIcon },
  { id: 'gift', icon: GiftIcon },
  { id: 'coffee', icon: CoffeeIcon },
  { id: 't-shirt', icon: TShirtIcon },
  { id: 'crown', icon: CrownIcon },
  // Three additions to round out the grid (5×6) and cover real ICP slots:
  // BookOpen (writers/blog), MapPin (local businesses), Users (community).
  { id: 'book-open', icon: BookOpenIcon },
  { id: 'map-pin', icon: MapPinIcon },
  { id: 'users', icon: UsersIcon },
];

// Project identity colors are semantic theme tokens, rather than raw hex
// utilities, so the picker stays legible in both light and dark themes.
// `swatchClass` is intentionally static so Tailwind emits every utility used by
// the picker (runtime string construction would be purged).
export const FOLDER_COLORS = [
  {
    id: 'neutral',
    bgClass: 'bg-muted/30',
    textClass: 'text-muted-foreground',
    swatchClass: 'bg-muted-foreground/40',
  },
  {
    id: 'red',
    bgClass: 'bg-project-red/10',
    textClass: 'text-project-red',
    swatchClass: 'bg-project-red',
  },
  {
    id: 'orange',
    bgClass: 'bg-project-orange/10',
    textClass: 'text-project-orange',
    swatchClass: 'bg-project-orange',
  },
  {
    id: 'yellow',
    bgClass: 'bg-project-yellow/10',
    textClass: 'text-project-yellow',
    swatchClass: 'bg-project-yellow',
  },
  {
    id: 'green',
    bgClass: 'bg-project-green/10',
    textClass: 'text-project-green',
    swatchClass: 'bg-project-green',
  },
  {
    id: 'blue',
    bgClass: 'bg-project-blue/10',
    textClass: 'text-project-blue',
    swatchClass: 'bg-project-blue',
  },
  {
    id: 'purple',
    bgClass: 'bg-project-purple/10',
    textClass: 'text-project-purple',
    swatchClass: 'bg-project-purple',
  },
  {
    id: 'pink',
    bgClass: 'bg-project-pink/10',
    textClass: 'text-project-pink',
    swatchClass: 'bg-project-pink',
  },
];
export function getFolderIcon(iconId?: string) {
  const item = FOLDER_ICONS.find((i) => i.id === iconId);
  return item ? item.icon : FolderIcon;
}

export function getFolderColor(colorId?: string) {
  const colorItem = FOLDER_COLORS.find((c) => c.id === colorId);
  return colorItem || FOLDER_COLORS[0];
}
